import React from 'react';
import { V } from '../../common/Layout';
import EllipsisText from '../../common/components/EllipsisText';
import LineClamp from '../components/LineClamp';
import { TYPE_TO_ICON } from '../icons/typeToIcon';
import LexicalRendererFooter from '../lexicalRenderer/LexicalRendererFooter';
import { hexToRgba, stringToColor } from '../utils/themeUtils';

type ReportGalleryCardProps = {
    item: {
        id: string;
        name: string;
        description: string;
        type: string;
        createdByName: string;
        updatedByName: string;
        createdOn: string;
        updatedOn?: string;
    };
};

function ReportGalleryCard({ item }: ReportGalleryCardProps) {
    const IconComponent = TYPE_TO_ICON[item.type];
    const iconColor = hexToRgba(stringToColor(item.name), 0.15);
    const showIcon = false; // icon will stay hidden until we get more of them per type
    return (
        <V fill sx={{ overflow: 'hidden', width: '100%', position: 'relative', p: 2, justifyContent: 'space-between' }}>
            <V gap={1} sx={{ overflow: 'hidden', width: '100%' }}>
                <EllipsisText
                    sx={{ fontWeight: 500, fontSize: 16, color: 'text.primary' }}
                    text={item.name}
                    onClick={() => {}}
                />
                <LineClamp sx={{ color: 'text.secondary', fontSize: 12 }} text={item.description} lineClamp={2} />
            </V>

            {IconComponent && showIcon && (
                <IconComponent
                    sx={{
                        color: iconColor,
                        position: 'absolute',
                        bottom: -10,
                        right: 2,
                        width: '65px',
                        height: '65px',
                        verticalAlign: 'bottom'
                    }}
                />
            )}

            <LexicalRendererFooter updatedOn={item?.updatedOn} updatedByName={item?.updatedByName} />
        </V>
    );
}

export default ReportGalleryCard;
